import { DeliveryModes, PractitionerTypes, FacilityTypes } from './schema'

export const therapiesServices = [
  {
    serviceId: 'THERAPY_001',
    serviceName: 'Physiotherapy Session',
    category: 'Therapies',
    specialty: 'Physiotherapy',
    subCategory: 'Physical Rehabilitation',
    description: 'Physical therapy for injury recovery and mobility improvement',
    cost: 350,
    durationMinutes: 45,
    deliveryModes: [DeliveryModes.IN_PERSON, DeliveryModes.HOME_VISIT],
    requiredPractitionerType: PractitionerTypes.ALLIED_HEALTH,
    status: 'active',
    billingCode: 'THERAPY_PHYSIO',
    billableItems: [],
    facilityTypes: [FacilityTypes.CLINIC, FacilityTypes.WELLNESS_CENTER],
    customisable: true,
    tags: ['physiotherapy', 'rehabilitation', 'mobility'],
    displayOrder: 1
  },
  {
    serviceId: 'THERAPY_002',
    serviceName: 'Psychotherapy Session',
    category: 'Therapies',
    specialty: 'Psychology',
    subCategory: 'Mental Health',
    description: 'Individual counseling and psychotherapy session',
    cost: 450,
    durationMinutes: 50,
    deliveryModes: [DeliveryModes.IN_PERSON, DeliveryModes.VIRTUAL],
    requiredPractitionerType: PractitionerTypes.ALLIED_HEALTH,
    status: 'active',
    billingCode: 'THERAPY_PSYCHO',
    billableItems: [],
    facilityTypes: [FacilityTypes.CLINIC, FacilityTypes.WELLNESS_CENTER],
    customisable: true,
    tags: ['psychology', 'counseling', 'mental health'],
    displayOrder: 2
  },
  {
    serviceId: 'THERAPY_003',
    serviceName: 'Dietitian Consultation',
    category: 'Therapies',
    specialty: 'Nutrition',
    subCategory: 'Nutritional Counseling',
    description: 'Nutritional assessment and dietary planning consultation',
    cost: 300,
    durationMinutes: 45,
    deliveryModes: [DeliveryModes.IN_PERSON, DeliveryModes.VIRTUAL],
    requiredPractitionerType: PractitionerTypes.ALLIED_HEALTH,
    status: 'active',
    billingCode: 'THERAPY_DIET',
    billableItems: [],
    facilityTypes: [FacilityTypes.CLINIC, FacilityTypes.WELLNESS_CENTER],
    customisable: true,
    tags: ['dietitian', 'nutrition', 'diet'],
    displayOrder: 3
  },
  {
    serviceId: 'THERAPY_004',
    serviceName: 'Occupational Therapy',
    category: 'Therapies',
    specialty: 'Occupational Therapy',
    subCategory: 'Functional Rehabilitation',
    description: 'Occupational therapy for daily living skills and workplace adaptation',
    cost: 380,
    durationMinutes: 45,
    deliveryModes: [DeliveryModes.IN_PERSON, DeliveryModes.HOME_VISIT, DeliveryModes.WORKPLACE],
    requiredPractitionerType: PractitionerTypes.ALLIED_HEALTH,
    status: 'active',
    billingCode: 'THERAPY_OT',
    billableItems: [],
    facilityTypes: [FacilityTypes.CLINIC, FacilityTypes.WELLNESS_CENTER],
    customisable: true,
    tags: ['occupational therapy', 'rehabilitation', 'workplace'],
    displayOrder: 4
  },
  {
    serviceId: 'THERAPY_005',
    serviceName: 'Speech Therapy',
    category: 'Therapies',
    specialty: 'Speech Pathology',
    subCategory: 'Communication Disorders',
    description: 'Speech and language therapy for communication disorders',
    cost: 400,
    durationMinutes: 45,
    deliveryModes: [DeliveryModes.IN_PERSON, DeliveryModes.VIRTUAL],
    requiredPractitionerType: PractitionerTypes.ALLIED_HEALTH,
    status: 'active',
    billingCode: 'THERAPY_SPEECH',
    billableItems: [],
    facilityTypes: [FacilityTypes.CLINIC, FacilityTypes.WELLNESS_CENTER],
    customisable: true,
    tags: ['speech therapy', 'communication', 'language'],
    displayOrder: 5
  },
  {
    serviceId: 'THERAPY_006',
    serviceName: 'Massage Therapy',
    category: 'Therapies',
    specialty: 'Massage Therapy',
    subCategory: 'Therapeutic Massage',
    description: 'Therapeutic massage for muscle tension and relaxation',
    cost: 250,
    durationMinutes: 60,
    deliveryModes: [DeliveryModes.IN_PERSON, DeliveryModes.HOME_VISIT],
    requiredPractitionerType: PractitionerTypes.ALLIED_HEALTH,
    status: 'active',
    billingCode: 'THERAPY_MASSAGE',
    billableItems: [],
    facilityTypes: [FacilityTypes.CLINIC, FacilityTypes.WELLNESS_CENTER],
    customisable: true,
    tags: ['massage', 'therapeutic', 'relaxation'],
    displayOrder: 6
  }
]

export default therapiesServices
